<template>
  <div id="profile">
    <section>
      <div v-if="currentClient">
        <h2>{{ currentClient.name }}</h2>
        <div v-if="isEditMode">
          <p>Enrichment Details</p>
          <form @submit.prevent>
            <label for="client">Company Name</label>
            <input
              v-model.trim="clientForm.name"
              type="text"
              placeholder="WidgetCo, Inc"
              id="client"
            />
            <button @click="updateClient" class="button">Save Changes</button>
          </form>
        </div>
        <div v-else>
          <div class="display-mode">
            <a @click="editClient" class="edit-button">
              <img src="../assets/pencil.svg" alt="Edit Client" />
            </a>
            <label>Company Name</label>
            <div>{{ currentClient.name }}</div>
            <div>{{ isEditMode }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <h2>Select a client to work with</h2>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { clientsCollection } from "../firebaseConfig";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      clientForm: {
        name: ""
      },
      isEditMode: false
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "clients", "currentClient"])
  },
  methods: {
    updateClient() {
      fb.clientsCollection
        .doc(this.currentClient.id)
        .update({
          name: this.clientForm.name
        })
        .then(ref => {
          this.isEditMode = false;
        })
        .catch(err => {
          console.log(err);
        });
      this.$store.dispatch("fetchCurrentClient");
    },
    editClient() {
      this.clientForm.name = this.currentClient.name;
      this.isEditMode = true;
    }
  }
};
</script>
